<template>
  <div class="text-sm md:text-md">
    <!-- Button trigger modal -->
    <button type="button"
      class="inline-block w-full md:w-auto bg-primary p-2.5 px-3 rounded-full text-white capitalize py-2.5 font-medium text-xs leading-tight shadow-md hover:bg-primary hover:shadow-lg focus:bg-primary focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
      data-bs-toggle="modal" data-bs-target="#staticBackdrop">
      add task
    </button>

    <!-- Modal -->
    <div
      class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-transparent"
      id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog relative w-auto pointer-events-none">
        <div
          class="modal-content border-none shadow-lg relative flex flex-col w-full modal-xl pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current md:right-16 mx-auto top-5"
          style="width: 70vw">
          <div
            class="modal-header flex flex-shrink-0 items-center justify-between p-3 border-b border-gray-200 rounded-t-md border-b-1.5 mb-3">
            <h5 class="text-md font-medium leading-normal text-gray-800 capitalize" id="exampleModalLabel">
              New task
            </h5>
            <button type="button"
              class="btn-close box-content w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal" aria-label="Close" />
          </div>

          <div class="modal-body relative mx-2 md:mx-5">
            <form class="flex justify-between flex-wrap md:flex-none">
              <!-- Task name -->
              <div class="mb-3 mx-2 md:mx-5 text-xs md:text-sm w-full xl:w-96">
                <label for="taskName" class="form-label inline-block mb-2 text-gray-700">Task Name</label>
                <input type="text"
                  class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border-0.5 border-solid border-gray-300 rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-700 focus:outline-none"
                  id="taskName" placeholder="System design" style="background-color: #f3f3f3" required
                  @change="handleTaskNameChange" />
              </div>
              <!-- Start date -->
              <div class="mb-3 mx-2 md:mx-5 text-xs md:text-sm w-full xl:w-96">
                <label for="startDate" class="form-label inline-block mb-2 text-gray-700">Start Date</label>
                <input type="date"
                  class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border-0.5 border-solid border-gray-300 rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-700 focus:outline-none"
                  id="startDate" placeholder="Start Date" style="background-color: #f3f3f3"
                  @change="handleStartDateChange" />
              </div>

              <!-- End date -->
              <div class="mb-3 mx-2 md:mx-5 text-xs md:text-sm w-full xl:w-96">
                <label for="endDate" class="form-label inline-block mb-2 text-gray-700">End Date</label>
                <input type="date"
                  class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-clip-padding border-0.5 border-solid border-gray-300 rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-700 focus:outline-none"
                  id="endDate" placeholder="End Date" style="background-color: #f3f3f3" @change="handleEndDateChange" />
              </div>

              <!-- urgency -->

              <div class="mb-3 mx-2 md:mx-5 text-xs md:text-sm w-full xl:w-96">
                <label for="endDate" class="form-label inline-block mb-2 text-gray-700">Urgency</label>
                <div class="w-full px-3 py-2 rounded-2xl flex justify-between border-0.5" style="
                      background-color: #f3f3f3;
                      justify-items: center;
                      align-items: center;
                    ">
                  <div class="form-check form-check-inline w-full" v-for="urgency of urgencies" :key="urgency.id">
                    <input v-if="urgency.name === 'urgent'"
                      class="form-check-input form-check-input appearance-none rounded-full h-3 w-3 md:h-4 md:w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-middle bg-no-repeat bg-center bg-contain pr-0.5 cursor-pointer"
                      type="radio" name="urgency" checked :id="urgency.id" :value="urgency.name"
                      @change="handleUrgencyChange" />
                    <input v-else
                      class="form-check-input form-check-input appearance-none rounded-full h-3 w-3 md:h-4 md:w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-middle bg-no-repeat bg-center bg-contain pr-0.5 cursor-pointer"
                      type="radio" name="urgency" :id="urgency.id" :value="urgency.name" @change="handleUrgencyChange" />
                    <label class="form-check-label inline-block text-gray-800 capitalize cursor-pointer border-primary"
                      :for="urgency.id">{{ urgency.name }}</label>
                  </div>
                </div>
              </div>

              <!-- Assign Employees -->
              <div class="mb-3 mx-2 md:mx-5 w-full rounded-2xl">
                <multiselect v-model="value" :options="options" :selected="multiValue" :multiple="true" :searchable="true"
                  :close-on-select="false" :clear-on-select="false" :limit="3" track-by="id" @update="updateMultiValue"
                  placeholder="Start typing or click to select" label="name" key="name" class="w-full rounded-2xl"
                  style="background-color: #f3f3f3">
                </multiselect>
              </div>

              <!-- Description -->
              <div class="mb-3 w-full mx-2 md:mx-5">
                <label for="description" class="form-label inline-block mb-2 text-gray-700">Description</label>
                <textarea
                  class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none border-0.5 rounded-2xl"
                  id="description" rows="3" placeholder="Description" @change="handleDescriptionChange"
                  style="background-color: #f3f3f3"></textarea>
              </div>

              <!-- File Dropzone -->
              <div class="mb-3 w-full mx-2 md:mx-5">
                <label for="files" class="form-label inline-block mb-2 text-gray-700">Files</label>
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :duplicateCheck="true"
                  class="w-full hover:text-yellow-400 cursor-pointer text-lg border-0.5 border-dashed rounded-2xl"
                  @change="handleFilesChange" style="background-color: #f3f3f3; border-width: 0.1px"></vue-dropzone>
              </div>
            </form>
          </div>
          <div
            class="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button type="submit"
              class="inline-block px-6 py-2.5 bg-primary text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-yellow-500 hover:shadow-lg focus:bg-yellow-500 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal" @click="handleSubmit">
              Submit
            </button>
            <button @click="handleCancel" type="button"
              class="inline-block px-6 py-2.5 bg-red-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Multiselect from "vue-multiselect";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    Multiselect,
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      selected: null,
      currentUser: null,
      multiValue: [],
      value: [],
      options: [
        { id: 1, name: "John Maxwell", department: "IT" },
        { id: 2, name: "Jane Maxwell", department: "Functional" },
        { id: 3, name: "Ray Broman", department: "Finance" },
        { id: 4, name: "Getenga", department: "IT" },
        { id: 5, name: "Anjette", department: "IT" },
        { id: 6, name: "Roselyne", department: "Marketting" },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      urgencies: [
        {
          id: 1,
          name: "mild",
        },
        {
          id: 2,
          name: "urgent",
        },
        {
          id: 3,
          name: "trivial",
        },
      ],

      newTasktask: {
        taskName: "",
        issuedBy: this.currentUser,
        startDate: "",
        endDate: "",
        status: "Ongoing",
        urgency: "",
        assignees: [],
        files: [],
      },
    };
  },
  created() {
    const { Role, UserName } = this.$store.getters.getUser;
    this.currentUser = { Role, UserName };
  },
  methods: {
    updateMultiValue(value) {

      this.multiValue = value;
    },
    styleItem({ name }) {
      return name;
    },
    removeFile() {
      this.$refs.myVueDropzone.removeFile();
    },
    handleTaskNameChange(event) {
      this.newTasktask.taskName = event.target.value;
    },
    handleStartDateChange(event) {
      this.newTasktask.startDate = event.target.value;
    },
    handleEndDateChange(event) {
      this.newTasktask.endDate = event.target.value;
    },
    handleUrgencyChange(event) {
      this.newTasktask.urgency = event.target.value;
    },
    handleAssigneeChange(event) {
      this.newTasktask.assignees = event.target.value;
    },
    handleFilesChange() {
      this.newTasktask.files = this.value;
    },
    handleDescriptionChange(event) {
      this.newTasktask.files = event.target.value;
    },
    handleCancel() {

    },
    handleSubmit(event) {
      event.preventDefault();

    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: yellow !important;
}

.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background-color: yellow !important;
}
</style>
